// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_30JmF","time":"_3mJwk"};